<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="row col-12 text-brand-5" @click="voltar()">
        <q-icon size="sm" name="arrow_back_ios" class="cursor" />
        <p class="text-h6 text-weight-bold text-brand-1 texto-titulo">
          Detalhe Centro de Custo: {{ centroDeCustoDetalhes.code }}
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-ml-sm q-mt-md text-brand-5 q-gutter-sm text-weight-bold container-inputs"
    >
      <div class="col-md-3 col-sm-5 col-xs-5">
        <div class="q-ml-sm titulo-input">Código</div>
        <q-input
          v-model="centroDeCustoDetalhes.code"
          dense
          outlined
          class="input input-new-design"
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm titulo-input">Descrição (Setor)</div>
        <q-input
          class="input input-new-design"
          v-model="centroDeCustoDetalhes.name"
          dense
          outlined
        />
      </div>

      <div class="col-md-2 col-sm-4 col-xs-4">
        <div class="texto-titulo-input">
          Dono
          <span
            @click="usuariosVisivel = true"
            style="cursor: pointer"
            class="text-brand-1"
            >(Alterar)</span
          >
        </div>

        <SelecaoSolicitante
          v-if="usuariosVisivel == true"
          @emitirFuncionario="receberFuncionario"
        />

        <q-input
          v-if="centroDeCustoDetalhes.owner != null && usuariosVisivel != true"
          v-model="centroDeCustoDetalhes.owner.name"
          class="input input-new-design"
          dense
          outlined
          disable
          bg-color="brand-7"
        />
        <q-input
          v-if="centroDeCustoDetalhes.owner == null && usuariosVisivel != true"
          class="input input-new-design"
          dense
          outlined
          disable
          bg-color="brand-7"
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm titulo-input">Matricula</div>
        <q-input
          v-if="centroDeCustoDetalhes.owner != null"
          class="input input-new-design"
          v-model="centroDeCustoDetalhes.owner.sap"
          dense
          outlined
          disable
          bg-color="brand-7"
        />
        <q-input
          v-else
          class="input input-new-design"
          dense
          outlined
          disable
          bg-color="brand-7"
        />
      </div>
      <div class="col-md-2 col-sm-4 col-xs-4">
        <div class="q-ml-sm titulo-input">Conta</div>
        <q-input
          class="input input-new-design"
          v-model="centroDeCustoDetalhes.conta"
          dense
          outlined
        />
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-sm btn"
          label="Editar"
          icon="edit"
          no-caps
          style="
            background-color: #21324a;
            border-radius: 8px;
            color: white;
            font-weight: normal;
          "
          @click="editarDadosCentroDeCusto()"
        />
      </div>
    </div>
    <!-- <div
      v-if="usuariosVisivel"
      class="col-12 text-brand-5 q-mt-xl q-mb-xl q-ml-md container-lista-usuarios"
    >
      <div class="row col-12 items-center">
        <div class="row col-12 justify-between items-center">
          <div>
            <div
              class="text-brand-5 text-weight-bold text-subtitle1 texto-titulo-tabela"
            >
              Selecione os Usuários
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-xs-12">
            <q-input
              v-model="busca"
              rounded
              dense
              outlined
              debounce="200"
              placeholder="Pesquisar"
              class="input-buscar"
            >
              <template v-slot:prepend>
                <q-icon name="search" />
              </template>
            </q-input>
          </div>
        </div>
        <q-linear-progress
          size="xs"
          class="q-mt-sm"
          v-if="loadingInner"
          indeterminate
        />
        <div class="row col-12 q-mt-lg text-weight-regular">
          <div
            style="max-width: 500px"
            class="container-radio-solicitante"
            v-for="(usuario, index) in listaUsuariosDonos"
            :key="index"
          >
            <q-radio
              class="radio-grupo"
              :val="usuario.id"
              :label="usuario.name"
              v-model="donoId"
            >
            </q-radio>
          </div>
        </div>
      </div>
    </div>-->
    <div class="q-mt-xl">
      <q-table
        :columns="columns"
        :rows="listaUsuariosCentroDeCusto.users"
        table-header-class="bg-accent text-weight-bold"
        flat
        dense
        hide-bottom
        class="tabela-tamanho-fixo"
        :grid="$q.screen.lt.sm"
        :loading="loading"
        hide-pagination
        :rows-per-page-options="[0]"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>

        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Usuários Aprovadores do Centro de Custo</span
          >
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div class="row col-12 items-center justify-between">
                <div class="row col-12">
                  <span class="q-ml-sm q-mt-sm"
                    ><strong>ID: </strong>{{ props.row.id }}</span
                  >
                </div>
                <div class="row col-12">
                  <span class="q-ml-sm"
                    ><strong>Matrícula: </strong>{{ props.row.sap }}</span
                  >
                </div>
                <span class="row col-12 q-ml-sm"
                  ><strong>Nome: </strong>{{ props.row.name }}</span
                >
                <div class="row col-12">
                  <span class="q-ml-sm"
                    ><strong>Email: </strong>{{ props.row.email }}</span
                  >
                </div>
                <div class="row col-12">
                  <span class="q-ml-sm"
                    ><strong>Aprovador: </strong
                    >{{ props.row.pivot.approver }}</span
                  >
                </div>
                <div class="row col-12">
                  <span class="q-ml-sm"
                    ><strong>Data de Admissão: </strong
                    >{{
                      props.row.admission_date
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-id="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.id }}
          </q-td>
        </template>
        <template v-slot:body-cell-matricula="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.sap }}
          </q-td>
        </template>
        <template v-slot:body-cell-nome="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.name }}
          </q-td>
        </template>
        <template v-slot:body-cell-email="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.email }}
          </q-td>
        </template>
        <template v-slot:body-cell-aprovador="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.pivot.approver == 1 ? "Sim" : "Não" }}
          </q-td>
        </template>
        <template v-slot:body-cell-criadoem="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              props.row.admission_date
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}
          </q-td>
        </template>
      </q-table>
    </div>
    <div class="q-mt-xl">
      <q-table
        :columns="columns2"
        :rows="listaUsuariosCentroDeCusto.user"
        table-header-class="bg-accent text-weight-bold"
        flat
        dense
        hide-bottom
        class="tabela-tamanho-fixo"
        :grid="$q.screen.lt.sm"
        :loading="loading"
        hide-pagination
        :rows-per-page-options="[0]"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>

        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Usuários de EPI do Centro de Custo</span
          >
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div class="row col-12 items-center justify-between">
                <div class="row col-12">
                  <span class="q-ml-sm q-mt-sm"
                    ><strong>ID: </strong>{{ props.row.id }}</span
                  >
                </div>
                <span class="row col-12 q-ml-sm"
                  ><strong>Nome: </strong>{{ props.row.name }}</span
                >
                <div class="row col-12">
                  <span class="q-ml-sm q-mt-sm"
                    ><strong>Matrícula: </strong>{{ props.row.sap }}</span
                  >
                </div>

                <div class="row col-12">
                  <span class="q-ml-sm"
                    ><strong>Email: </strong>{{ props.row.email }}</span
                  >
                </div>
                <div class="row col-12">
                  <span class="q-ml-sm"
                    ><strong>Data de Admissão: </strong
                    >{{
                      props.row.admission_date
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-id="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.id }}
          </q-td>
        </template>

        <template v-slot:body-cell-nome="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.name }}
          </q-td>
        </template>

        <template v-slot:body-cell-matricula="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.sap }}
          </q-td>
        </template>
        <template v-slot:body-cell-email="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.email }}
          </q-td>
        </template>
        <template v-slot:body-cell-criadoem="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              props.row.admission_date
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}
          </q-td>
        </template>
      </q-table>
    </div>
  </q-page>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import SelecaoSolicitante from "../components/SelecaoSolicitante.vue";
const columns = [
  { name: "id", label: "ID", align: "left", style: "width: 10%" },
  { name: "nome", label: "Nome", align: "left", style: "width: 25%" },
  { name: "matricula", label: "Matrícula", align: "left", style: "width: 15%" },
  { name: "email", label: "Email", align: "left", style: "width: 30%" },
  { name: "criadoem", label: "Criado Em", align: "left", style: "width: 10%" },
  { name: "aprovador", label: "Aprovador", align: "left", style: "width: 10%" },
];

const columns2 = [
  { name: "id", label: "ID", align: "left", style: "width: 10%" },
  { name: "nome", label: "Nome", align: "left", style: "width: 25%" },
  { name: "matricula", label: "Matrícula", align: "left", style: "width: 15%" },
  { name: "email", label: "Email", align: "left", style: "width: 30%" },
  { name: "criadoem", label: "Criado Em", align: "left", style: "width: 10%" },
  { name: "", label: "", align: "left", style: "width: 10%" },
];
export default {
  components: {
    SelecaoSolicitante,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const quasar = useQuasar();

    const centroDeCustoId = route.params.centroCustoId;
    const centroDeCustoDetalhes = ref({ owner: { name: "", sap: "" } });
    const listaUsuariosCentroDeCusto = ref([]);
    const listaUsuariosDonos = ref([]);
    const donoId = ref();
    let loading = ref(false);
    let usuariosVisivel = ref(false);
    const busca = ref("");
    let loadingInner = ref(false);

    const detalharCentroDeCusto = async () => {
      const response = await store.dispatch(
        "centroDeCusto/detalharCentroDeCusto",
        {
          cost_center_id: centroDeCustoId,
        }
      );
      centroDeCustoDetalhes.value = response.data.model;
      if (centroDeCustoDetalhes.value.owner == null) {
        centroDeCustoDetalhes.value.owner = { name: "", sap: "" };
      }
    };

    const listarUsuariosDoCentroDeCusto = async () => {
      loading.value = true;
      const response = await store.dispatch(
        "centroDeCusto/listarUsuariosDoCentroDeCusto",
        {
          cost_center_id: centroDeCustoId,
        }
      );
      listaUsuariosCentroDeCusto.value = response.data.results[0];
      loading.value = false;
    };

    const voltar = async () => {
      router.push({ name: "centrodecusto-listar" });
    };

    const editarDadosCentroDeCusto = async () => {
      try {
        await store.dispatch("centroDeCusto/alterarDadosCentroDeCusto", {
          cc_id: centroDeCustoDetalhes.value.id,
          code: centroDeCustoDetalhes.value.code,
          conta: centroDeCustoDetalhes.value.conta,
          name: centroDeCustoDetalhes.value.name,
          owner_id: donoId.value,
        });
        detalharCentroDeCusto();
        donoId.value = "";
        usuariosVisivel.value = false;
        quasar.notify({
          message: "Dados do centro de custo alterados com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        let mensagem = "Erro ao alterar dados do centro de custo";
        if (error.response.data.message) {
          mensagem = error.response.data.message;
        }
        quasar.notify({
          message: mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const listarUsuariosDonos = async () => {
      let perPage = 20;
      if (quasar.platform.is.mobile) {
        perPage = 10;
      }
      loadingInner.value = true;
      const response = await store.dispatch(
        "centroDeCusto/listarUsuariosDonos",
        {
          per_page: perPage,
          search: busca.value,
        }
      );
      listaUsuariosDonos.value = response.data.results.data;
      loadingInner.value = false;
    };

    watch(
      () => busca.value,
      () => {
        listarUsuariosDonos();
      }
    );

    watch(
      () => donoId.value,
      () => {
        if (donoId.value != "") {
          editarDadosCentroDeCusto();
        }
      }
    );

    const receberFuncionario = (value) => {
      if (value.tipo != "geral") {
        donoId.value = value.id;
      }
    };

    onMounted(detalharCentroDeCusto);
    onMounted(listarUsuariosDoCentroDeCusto);
    onMounted(listarUsuariosDonos);

    return {
      columns,
      columns2,
      centroDeCustoId,
      detalharCentroDeCusto,
      centroDeCustoDetalhes,
      voltar,
      listarUsuariosDoCentroDeCusto,
      listaUsuariosCentroDeCusto,
      editarDadosCentroDeCusto,
      donoId,
      loading,
      usuariosVisivel,
      listarUsuariosDonos,
      busca,
      listaUsuariosDonos,
      loadingInner,
      receberFuncionario,
    };
  },
};
</script>

<style scoped>
.cursor {
  cursor: pointer;
  margin-top: 3px;
}
a {
  color: #213864;
}

@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }

  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .cursor {
    margin-top: 13px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .titulo-input {
    font-size: 12px;
    margin: 0px;
  }
  .btn {
    margin: 6px 0px 0px 0px;
  }
  .input {
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 14px;
  }
  .container-lista-usuarios {
    margin: 40px 0px 0px 0px;
  }
  .input-buscar {
    margin: 10px 0px;
    font-size: 12px;
  }
  .radio-grupo {
    font-size: 12px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
}
</style>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
.titulo-input {
}
</style>
